import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outlet-manager',
  templateUrl: './outlet-manager.component.html',
  styleUrls: ['./outlet-manager.component.scss']
})
export class OutletManagerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
